var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showDialog
        ? _c("ModalFullScreen", {
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("ModalHeader", { attrs: { title: _vm.modalTitle } }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "form",
                  fn: function () {
                    return [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ handleSubmit }) {
                                return [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "company name",
                                      rules: "required_field",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  title: "Company Name*",
                                                  name: "company name",
                                                  placeholder:
                                                    "Enter company name",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.companyName,
                                                  callback: function ($$v) {
                                                    _vm.companyName = $$v
                                                  },
                                                  expression: "companyName",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "job title",
                                      rules: "required_field",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  title: "Job Title*",
                                                  name: "job title",
                                                  placeholder:
                                                    "Enter job title",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.jobTitle,
                                                  callback: function ($$v) {
                                                    _vm.jobTitle = $$v
                                                  },
                                                  expression: "jobTitle",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "location",
                                      rules: "required_field",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  title: "Location*",
                                                  name: "location",
                                                  placeholder: "Enter location",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.location,
                                                  callback: function ($$v) {
                                                    _vm.location = $$v
                                                  },
                                                  expression: "location",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-1 grid grid-cols-2 gap-8",
                                    },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          vid: "start_date",
                                          name: "start date",
                                          rules: "noFutureDate:@ongoing",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        title: "Start Date",
                                                        name: "start date",
                                                        errors: errors,
                                                      },
                                                    },
                                                    [
                                                      _c("FormDatepicker", {
                                                        model: {
                                                          value: _vm.startDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.startDate = $$v
                                                          },
                                                          expression:
                                                            "startDate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                      _c(
                                        "div",
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              vid: "end_date",
                                              name: "end date",
                                              rules:
                                                "noBeforeDate:@start_date,@ongoing",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "FormGroup",
                                                        {
                                                          attrs: {
                                                            title: "End Date",
                                                            name: "end date",
                                                            errors: errors,
                                                          },
                                                        },
                                                        [
                                                          _c("FormDatepicker", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.ongoing,
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.endDate,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.endDate =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "endDate",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c(
                                            "ValidationProvider",
                                            {
                                              attrs: {
                                                vid: "ongoing",
                                                name: "ongoing",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex items-start",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex items-center h-5",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.ongoing,
                                                            expression:
                                                              "ongoing",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                                                        attrs: {
                                                          type: "checkbox",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              _vm.ongoing
                                                            )
                                                              ? _vm._i(
                                                                  _vm.ongoing,
                                                                  null
                                                                ) > -1
                                                              : _vm.ongoing,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.ongoing,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.ongoing =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.ongoing =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.ongoing = $$c
                                                            }
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ml-1 text-sm leading-5",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "font-medium text-gray-700",
                                                          attrs: {
                                                            for: "comments",
                                                          },
                                                        },
                                                        [_vm._v(" Ongoing? ")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormGroup",
                                    { attrs: { title: "Note" } },
                                    [
                                      _c("FormTextarea", {
                                        attrs: {
                                          placeholder: "Summary",
                                          name: "experience summary",
                                        },
                                        model: {
                                          value: _vm.summary,
                                          callback: function ($$v) {
                                            _vm.summary = $$v
                                          },
                                          expression: "summary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormGroup",
                                    { attrs: { title: "Skills (3 Max)" } },
                                    [
                                      _c("SkillsMultiselect", {
                                        attrs: { max: 3 },
                                        model: {
                                          value: _vm.skillsIds,
                                          callback: function ($$v) {
                                            _vm.skillsIds = $$v
                                          },
                                          expression: "skillsIds",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormGroup",
                                    { attrs: { title: "Industry" } },
                                    [
                                      _c("IndustriesMultiselect", {
                                        attrs: { multiple: false },
                                        model: {
                                          value: _vm.industry,
                                          callback: function ($$v) {
                                            _vm.industry = $$v
                                          },
                                          expression: "industry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "FormGroup",
                                    { attrs: { title: "Employment Type" } },
                                    [
                                      _c("ExperienceEmploymentTypeSelect", {
                                        model: {
                                          value: _vm.employmentType,
                                          callback: function ($$v) {
                                            _vm.employmentType = $$v
                                          },
                                          expression: "employmentType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "pt-5 flex justify-end" },
                                    [
                                      _c("UIButton", {
                                        staticClass: "mr-3",
                                        attrs: {
                                          variant: "outline",
                                          buttonText: "Cancel",
                                        },
                                        on: { click: _vm.closeModal },
                                      }),
                                      _vm.isEditing
                                        ? _c("UIButton", {
                                            attrs: {
                                              variant: "black",
                                              buttonText: "Update",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return handleSubmit(_vm.submit)
                                              },
                                            },
                                          })
                                        : _c("UIButton", {
                                            attrs: {
                                              buttonText: "Add",
                                              variant: "black",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return handleSubmit(_vm.submit)
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2431445138
                        ),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1178996770
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }